import useUsageStore from '../stores/usageStore';
import useProductStore from '../stores/productStore';

const useIsLimitReached = () => {
    const { usage } = useUsageStore();
    const { currentProduct } = useProductStore();
    
    if (!usage || !currentProduct) return false;
    const limit = parseInt(currentProduct.metadata?.limit, 10);
    return usage.usage >= limit;
};

export default useIsLimitReached;
